<template>
  <div>
    <v-container grid-list-lg fluid>
        <v-layout row wrap>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <v-flex lg3 md12 sm12 pr-6 pl-lg-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuStart"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedStartDateFormatted"
                                label="Từ ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedEndDateFormatted"
                                label="Đến ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6 pt-0>
                    <v-select label="Hình thức" :items="reportTypes" v-model="selectedType" item-text="name" item-value="value" @change="filter_data"></v-select>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-btn @click="filter_data" color="#a77800" outlined>Xem</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <v-flex lg12>
            <v-card class="mb-8">
                <v-data-table :headers="headers" hide-default-footer :sortable="false" :items="items" :server-items-length="items ? items.length : 0" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td v-if="selectedType == 1">{{ item.CompletedDate }}</td>
                            <td v-else>{{ item.CompletedMonth }}</td>
                            <td class="text-end">{{ item.FeeBuyAmount | currency}}</td>
                            <td class="text-end">{{ item.FeeWeightAmount | currency}}</td>
                            <td class="text-end">{{ item.ExchangeRevenueVND | currency}}</td>
                            <td class="text-end">{{ item.BargainRevenueVND | currency}}</td>
                            <td class="text-end">{{ item.TotalRevenue | currency}}</td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr>
                            <td class="font-weight-bold">TỔNG</td>
                            <td class="font-weight-bold text-end">{{ summary.FeeBuyAmount | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.FeeWeightAmount | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.ExchangeRevenueVND | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.BargainRevenueVND | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalRevenue | currency }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment"
export default {
    data() {
        return {
            selectedType: 1,
            reportTypes: [
                {name: 'Theo ngày', value: 1},
                {name: 'Theo tháng', value: 2},
            ],
            viewName: "bao-cao-tong-hop",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            headers: [
                {
                    text: "Ngày",
                    value: "CompletedDate",
                    sortable: false,
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Phí dịch vụ",
                    value: "FeeBuyAmount",
                    sortable: false,
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí vận chuyển",
                    value: "FeeWeightAmount",
                    sortable: false,
                    filterable: true,
                    align: "end",
                    values: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chênh lệch tỷ giá",
                    value: "ExchangeRevenueVND",
                    sortable: false,
                    filterable: true,
                    align: "end",
                    values: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chênh lệch mặc cả",
                    value: "BargainRevenueVND",
                    sortable: false,
                    filterable: true,
                    align: "end",
                    values: configs.DATA_TYPE["Number"] 
                },
                {
                    text: "Tổng cộng",
                    value: "TotalRevenue",
                    sortable: false,
                    filterable: true,
                    align: "end",
                    values: configs.DATA_TYPE["Number"] 
                }
            ]
        };
    },
    computed: {
        ...mapState({
            items: state => state.report.generalReport.data,
            loading: state => state.report.loading
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        summary() {
            var ret = {
                'FeeBuyAmount': _.sumBy(this.items, 'FeeBuyAmount'),
                'FeeWeightAmount': _.sumBy(this.items, 'FeeWeightAmount'),
                'ExchangeRevenueVND': _.sumBy(this.items, 'ExchangeRevenueVND'),
                'BargainRevenueVND': _.sumBy(this.items, 'BargainRevenueVND'),
                'TotalRevenue': _.sumBy(this.items, 'TotalRevenue')
            };
            return ret;
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                reportType: this.selectedType
            };
            this.$store.dispatch("report/getGeneralReport", param);
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}
.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>